export default __webpack_public_path__ + "static/media/check.b52ae184.svg";